import { LocalShipping as TruckIcon } from "@mui/icons-material";
import { Box, Card, CardContent, Chip, Paper, Typography } from "@mui/material";
import { DataGrid, GridColDef, GridRowsProp } from "@mui/x-data-grid";
import { FC, memo } from "react";

const columns: GridColDef[] = [
  {
    field: "id",
    headerName: "LEG ID",
    width: 120,
    renderCell: (params) => (
      <Box display="flex" alignItems="center" gap={1}>
        <TruckIcon fontSize="small" />
        {params.value}
      </Box>
    ),
  },
  { field: "sectionType", headerName: "区間種別", width: 100 },
  { field: "deliveryMethod", headerName: "配送形態", width: 100 },
  { field: "shipperName", headerName: "荷主名", width: 120 },
  { field: "route", headerName: "区間", width: 200 },
  { field: "loadingAddress", headerName: "積地住所", width: 180 },
  { field: "unloadingAddress", headerName: "降地住所", width: 180 },
  { field: "loadingOn", headerName: "積日", width: 100 },
  { field: "unloadingOn", headerName: "降日", width: 100 },
  { field: "loadingTimeWindow", headerName: "積地指定時間", width: 120 },
  { field: "unloadingTimeWindow", headerName: "降地指定時間", width: 120 },
  { field: "loadingStayingMinutes", headerName: "積地滞在時間", width: 110 },
  { field: "unloadingStayingMinutes", headerName: "降地滞在時間", width: 110 },
  { field: "quantity", headerName: "数量", width: 80, type: "number" },
  { field: "weightKg", headerName: "重量", width: 80, type: "number" },
  { field: "volumeM3", headerName: "体積", width: 80, type: "number" },
  {
    field: "paymentAmountTotal",
    headerName: "支払金額合計",
    width: 120,
    type: "number",
    valueFormatter: (value: number) => `¥${value?.toLocaleString()}`,
  },
  {
    field: "dispatchStatus",
    headerName: "ステータス",
    width: 100,
    renderCell: (params) => (
      <Chip
        label={String(params.value)}
        size="small"
        color={params.value === "配車済" ? "success" : "warning"}
      />
    ),
  },
  { field: "carrierCompany", headerName: "運送会社", width: 120 },
  { field: "operatingCarrier", headerName: "実走行会社", width: 120 },
  { field: "truckNumber", headerName: "車番", width: 120 },
  { field: "driverName", headerName: "ドライバー", width: 100 },
  { field: "hierarchyLevel", headerName: "請負階層", width: 100 },
  { field: "planningLicenseName", headerName: "配車担当者", width: 120 },
];

interface ShipmentLegRunListCardProps {
  rows: GridRowsProp;
  title?: string;
}

const ShipmentLegRunListCardComponent: FC<ShipmentLegRunListCardProps> = ({
  rows,
  title = "関連LEG一覧",
}) => {
  const rowCountLabel = `${rows.length}件`;

  return (
    <Card sx={{ height: "100%" }}>
      <CardContent>
        <Typography variant="h6" fontWeight="bold" mb={2}>
          {title} ({rowCountLabel})
        </Typography>
        <Paper sx={{ height: "70vh" }}>
          <DataGrid
            rows={rows}
            columns={columns}
            hideFooter
            sx={{
              "& .MuiDataGrid-row:hover": {
                cursor: "pointer",
              },
            }}
          />
        </Paper>
      </CardContent>
    </Card>
  );
};

export const ShipmentLegRunListCard = memo(ShipmentLegRunListCardComponent);
